import { Observable } from 'rxjs/Observable';
import { ofType } from 'redux-observable';
import { catchError, mergeMap, switchMap, concatMap } from 'rxjs/operators';
import {
    CC_SET_CREDENTIAL_PIN,
    ccSetCredentialPinSuccessAction,
    ccSetCredentialPinFailedAction
} from '../actions/creditCardSetCredential';
import { encryption } from '../utils/utils';

import {
    moveCreditCardStepAction,
    showPinTechnicalErrorAction
} from '../actions/application';

import {
    CREDIT_CARD_ERROR_CODES,
    CREDIT_CARD_RESET_STEPS
} from '../constants';

export const ccSetCredentialObservable = ({
    sessionId,
    credential,
    type,
    time,
    creditCardSetCredentialService,
}) => {
    const encryptedCredential = encryption(credential, time, 'rp');
    return creditCardSetCredentialService({
        sessionId,
        credential: encryptedCredential,
        type,
        time
    }).pipe(
        mergeMap(() => {
            return Observable.of( 
                ccSetCredentialPinSuccessAction(),
                moveCreditCardStepAction(CREDIT_CARD_RESET_STEPS.password.stepId)
            )
        }),
        catchError(error => {
            const { errors } = error.response.data;
            const errorCode = 
                error.response.data.errorCode || 
                errors && errors[0].errorCode;
            if (error.response && error.response.status !== 401) {
                if( errorCode === CREDIT_CARD_ERROR_CODES.CREDIT_CARD_PROFILE_STILL_HOLD ) {
                    return Observable.of(
                        ccSetCredentialPinFailedAction(errorCode),
                        moveCreditCardStepAction(CREDIT_CARD_RESET_STEPS.password.stepId)
                    )
                } 
                return Observable.of(showPinTechnicalErrorAction(errorCode));
                
            }
            return Observable.of(showPinTechnicalErrorAction(errorCode));
        }),
    );
};

export const ccSetCredentialWithClientTimeObservable = ({
    sessionId,
    credential,
    type,
    creditCardSetCredentialService,
}) => {
    const time = new Date().getTime().toString();
    return ccSetCredentialObservable({
        sessionId,
        credential,
        type,
        time,
        creditCardSetCredentialService,
    });
};

export const setCredentialCCPinEpic = (
    action$,
    store,
    { creditCardSetCredentialService, getTimeService, getTimeAccessTokenService },
) =>
    action$.pipe(
        ofType(CC_SET_CREDENTIAL_PIN),
        switchMap(action => {
            const { sessionId, credential, type } = action.payload;
            return getTimeAccessTokenService().pipe(
                concatMap(response => {
                    const timeAccessToken = response.data.access_token;
                    return getTimeService(timeAccessToken).pipe(
                        concatMap(response => {
                            const time = response.data;
                            return ccSetCredentialObservable({
                                sessionId,
                                credential,
                                type,
                                time,
                                creditCardSetCredentialService,
                            });
                        }),
                        catchError(() => {
                            return ccSetCredentialWithClientTimeObservable({
                                sessionId,
                                credential,
                                type,
                                creditCardSetCredentialService,
                            });
                        }),
                    );
                }),
                catchError(() => {
                    return ccSetCredentialWithClientTimeObservable({
                        sessionId,
                        credential,
                        type,
                        creditCardSetCredentialService,
                    });
                }),
            );
        }),
    );
